// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.steps-container {
  border-radius: 30px;
  padding: 4px 4px !important;
  background-color: #e7f2f9;
  margin-top: 25px;
}
@media (max-width: 1200px) {
  .steps-container {
    margin-top: 18px;
  }
}

.steps-progress {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  gap: 10px;
}

.step-circle {
  width: 26px;
  height: 26px;
  min-width: 26px;
  border-radius: 50%;
  background-color: #ffffff;
  color: #666;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  display: flex;
  align-items: center;
  justify-content: center;
}
.step-circle.filled {
  background-color: #ece63d;
  border-color: #ece63d;
  cursor: pointer;
  color: #113b65;
}
.step-circle.submitted {
  background-color: #113b65;
  border-color: #113b65;
  cursor: pointer;
  color: #ffffff;
}
.step-circle.current {
  background-color: #ece63d;
  color: #113b65;
  border-color: #ece63d;
}

.step-item {
  flex: 1 !important;
  text-align: center;
  position: relative;
  gap: 12px;
}
.step-item .step-label {
  margin-top: 2px;
  font-size: 14px;
  color: #4f4f4f;
  font-weight: 500;
  line-height: 22px;
}
.step-item.active .step-circle {
  background-color: #ece63d;
}
.step-item.active:not(:last-child)::after {
  background-color: #007bff;
}
.step-item:not(:last-child)::after {
  content: "";
  position: absolute;
  top: 20px;
  right: -50%;
  width: 100%;
  height: 2px;
  background-color: #ddd;
  z-index: -1;
}
@media (max-width: 991px) {
  .step-item {
    flex: auto !important;
  }
  .step-item .step-label {
    font-size: 0;
    display: none;
  }
  .step-item.active {
    flex: 1 auto !important;
    width: 100%;
  }
  .step-item.active .step-label {
    font-size: 14px;
    display: block;
    white-space: nowrap;
  }
  .step-item:not(:last-child)::after {
    content: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/themes/DYHAC/app/shared/layout/stepperform/stepperform.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,2BAAA;EACA,yBAAA;EACA,gBAAA;AACF;AAAE;EALF;IAMI,gBAAA;EAGF;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAF;AAEE;EACE,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;AAAJ;AAGE;EACE,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;AADJ;AAIE;EACE,yBAAA;EACA,cAAA;EACA,qBAAA;AAFJ;;AAOA;EACE,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AAJF;AAME;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AAJJ;AASI;EACE,yBAAA;AAPN;AAWM;EACE,yBAAA;AATR;AAeI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,WAAA;AAbN;AAiBE;EAxCF;IAyCI,qBAAA;EAdF;EAgBE;IACE,YAAA;IACA,aAAA;EAdJ;EAiBE;IACE,uBAAA;IACA,WAAA;EAfJ;EAiBI;IACE,eAAA;IACA,cAAA;IACA,mBAAA;EAfN;EAoBI;IACE,aAAA;EAlBN;AACF","sourcesContent":[".steps-container {\n  border-radius: 30px;\n  padding: 4px 4px !important;\n  background-color: #e7f2f9;\n  margin-top: 25px;\n  @media (max-width: 1200px) {\n    margin-top: 18px;\n  }\n  // width: \"1043px\";\n  // height:\"34px\";\n}\n\n.steps-progress {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n  gap: 10px;\n}\n\n.step-circle {\n  width: 26px;\n  height: 26px;\n  min-width: 26px;\n  border-radius: 50%;\n  background-color: #ffffff;\n  color: #666;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.5;\n  // cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &.filled {\n    background-color: #ece63d;\n    border-color: #ece63d;\n    cursor: pointer;\n    color: #113b65;\n  }\n\n  &.submitted {\n    background-color: #113b65;\n    border-color: #113b65;\n    cursor: pointer;\n    color: #ffffff;\n  }\n\n  &.current {\n    background-color: #ece63d;\n    color: #113b65;\n    border-color: #ece63d;\n    // cursor: pointer;\n  }\n}\n\n.step-item {\n  flex: 1 !important;\n  text-align: center;\n  position: relative;\n  gap: 12px;\n\n  .step-label {\n    margin-top: 2px;\n    font-size: 14px;\n    color: #4f4f4f;\n    font-weight: 500;\n    line-height: 22px;\n    // lineHeight:\"22px\"\n  }\n\n  &.active {\n    .step-circle {\n      background-color: #ece63d;\n    }\n\n    &:not(:last-child) {\n      &::after {\n        background-color: #007bff;\n      }\n    }\n  }\n\n  &:not(:last-child) {\n    &::after {\n      content: '';\n      position: absolute;\n      top: 20px;\n      right: -50%;\n      width: 100%;\n      height: 2px;\n      background-color: #ddd;\n      z-index: -1;\n    }\n  }\n\n  @media (max-width: 991px) {\n    flex: auto !important;\n\n    .step-label {\n      font-size: 0;\n      display: none;\n    }\n\n    &.active {\n      flex: 1 auto !important;\n      width: 100%;\n\n      .step-label {\n        font-size: 14px;\n        display: block;\n        white-space: nowrap;\n      }\n    }\n\n    &:not(:last-child) {\n      &::after {\n        content: none;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
